<template>
  <div class="zhuaqiu-result-page">
    <img class="top-bg" src="/static/images/zq/bg2.png" />
    <div class="content-container">
      <img class="logo" src="/static/images/zq/logo.png" />
      <img class="system" src="/static/images/zq/system.png" />
      <img class="pitou2" src="/static/images/zq/pitou2.png" />
      <div class="result-content">
        <div class="white-box">
          <div class="result-text">
            <div class="text-line">
              <div class="text-label">产品真伪：</div>
              <div class="text-value">{{ queryResult }}</div>
            </div>
            <div class="text-line">
              <div class="text-label">首次查询时间：</div>
              <div class="text-value">{{ firstQueryTime }}</div>
            </div>
            <div class="text-line">
              <div class="text-label">最近查询时间：</div>
              <div class="text-value">{{ preQueryTime }}</div>
            </div>
          </div>
        </div>
        <img v-if="showButtons && digitCode" class="query-trace-btn" src="/static/images/zq/query-trace.png" @click="handleQueryTrace" />
        <img v-if="showButtons" class="join-btn" src="/static/images/zq/join.png" @click="handleJoin" />
      </div>
      <div class="bottom-bar"></div>
      <img class="bottom2" src="/static/images/zq/bottom2.png" />
    </div>
    <!-- Result页面内容 -->
  </div>
</template>

<style scoped>
.zhuaqiu-result-page {
  width: 100vw;
  min-height: 100vh;
  background-image: url('/static/images/zq/bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  position: relative;
}

.top-bg {
  width: 100vw;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.content-container {
  position: relative;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
}

.logo {
  width: 16vw;
  height: auto;
  margin-top: 4vh;
}

.system {
  width: 85vw;
  height: auto;
  margin-top: 4vh;
}

.pitou2 {
  width: 45vw;
  height: auto;
  margin-top: 4vh;
}

.result-content {
  position: fixed;
  top: 55%;
  left: 50%;
  transform: translateX(-50%);
  width: 84vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 100;
}

.white-box {
  width: 84vw;
  min-height: 20vh;
  background-color: white;
  border: 1px solid rgb(198, 0, 22);
  margin-bottom: 1.5vh;
  display: flex;
  align-items: center;
  padding-left: 3vw;
}

.result-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.text-line {
  display: flex;
  align-items: center;
  margin-bottom: 0.5vh;
}

.text-label {
  font-size: 3.8vw;
  color: black;
  text-align: justify;
  text-align-last: justify;
  width: 30vw;
  flex-shrink: 0;
}


.text-value {
  font-size: 3.8vw;
  color: black;
  text-align: left;
  flex-grow: 1;
}

.text-line:last-child {
  margin-bottom: 0;
}

.query-trace-btn {
  width: 86vw;
  height: auto;
  cursor: pointer;
  margin-bottom: 1.5vh;
}

.join-btn {
  width: 86vw;
  height: auto;
  cursor: pointer;
}

.bottom-bar {
  width: 100vw;
  height: 5vh;
  background-color: rgb(198, 0, 22);
  position: fixed;
  bottom: 0;
  left: 0;
}

.bottom2 {
  width: 50vw;
  height: auto;
  position: fixed;
  bottom: 1vh;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
}

@media screen and (max-height: 600px) {
  .logo {
    width: 12vw;
  }

  .system {
    width: 75vw;
  }

  .pitou2 {
    width: 40vw;
  }


}
</style>

<script>
import { queryAnti, getInfoByCode, getWechatAuth } from '../../api/api'
export default {
  name: 'ZhuaQiuResult',
  data() {
    return {
      eno: process.env.ENV_NUM === '1' ? '138495222640' : '138603493800',
      appId: process.env.ENV_NUM === '1' ? 'wx22242a811779ec8c' : 'wxbc22565b3e7a59fd',
      code: '',
      queryResult: '',
      firstQueryTime: '',
      preQueryTime: '',
      deptId: '',
      showButtons: false,
      digitCode: ''
    }
  },
  methods: {
    handleQueryTrace() {
      this.$router.push({
        path: '/zhuaqiu/trace',
        query: {
          eno: this.eno,
          c: this.digitCode
        }
      });
    },
    async queryAntiCode() {
      if (this.code && this.eno) {
        try {
          const res = await queryAnti(this.code, this.eno);
          const data = res.data;

          if (data == null || data.code == "500") {
            this.queryResult = "查询异常，请重新扫描防伪码进行查询";
            this.showButtons = false;
            return;
          }

          const replyCode = data.data.replyCode;

          if (replyCode === "300101" || replyCode === "300102") {
            this.queryResult = "产品为正品，请放心使用";
            this.firstQueryTime = data.data.firstQueryTime || '';
            this.preQueryTime = data.data.preQueryTime || '';
            this.deptId = data.data.deptId || '';
            this.showButtons = true;
          } else if (replyCode === "300106") {
            this.queryResult = "您查询的数码不存在！";
            this.showButtons = false;
          } else {
            this.queryResult = "查询结果异常，请联系客服";
            this.showButtons = false;
          }
        } catch (error) {
          console.error('防伪查询失败:', error);
          this.queryResult = "查询失败，请稍后重试";
          this.showButtons = false;
        }
      } else {
        this.queryResult = "请使用正确入口进入进行查询";
        this.showButtons = false;
      }
    },
    getProductInfo() {
      if (this.code) {
        getInfoByCode(this.code).then(res => {
          if (res.data.code === "200" && res.data.data) {
            this.digitCode = res.data.data.digitCode || '';
          } else {
            console.error('获取产品信息失败:', res.data);
          }
        }).catch(err => {
          console.error('获取产品信息失败:', err);
        });
      }
    },
    handleJoin() {
      const redirectUrl = window.location.origin + '/zhuaqiu/join';
      const params = new URLSearchParams();
      params.append('eno', this.eno);
      params.append('c', this.code);
      params.append('deptId', this.deptId);
      params.append('digit', this.digitCode);
      
      const fullRedirectUrl = redirectUrl + '?' + params.toString();
      
      getWechatAuth(encodeURIComponent(fullRedirectUrl), this.appId, 1).then(res => {
        const data = res.data;
        window.location.href = data;
      }).catch(err => {
        alert("获取微信授权失败" + err);
      });
    }
  },
  mounted() {
    const eno = this.$route.query.eno;
    const code = this.$route.query.c;
    if (eno) {
      this.eno = eno;
    }
    if (code) {
      this.code = code ? code.substring(0, 16) : '';
    }
    this.queryAntiCode();
    this.getProductInfo();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ZhuaQiu/Result.vue